import React from 'react';
import { Text, View,TouchableOpacity } from 'react-native';
import { Feather, Ionicons, Entypo } from '@expo/vector-icons';
import { useHistory } from '../../services/router';
import styles from './styles';

function BoxInfosControl({
	icon, children, title, type, to,
}) {
	const history = useHistory();
	const renderedIcon = () => {
		switch (type) {
			case 'Entypo':
				return <Entypo style={styles.icon} name={icon} />;
			case 'Feather':
				return <Feather style={styles.icon} name={icon} />;
			default:
				return <Ionicons style={styles.icon} name={icon} />;
		}
	};

	return (
		<TouchableOpacity onPress={() => history.push(to)}>
			<View accessible style={styles.container}>
				{renderedIcon()}
				<Text style={styles.text}>{children || title}</Text>
			</View>
		</TouchableOpacity>
	);
}

export default BoxInfosControl;
